export const getOSName = () => {
  const userAgent = navigator.userAgent;
  if (/windows phone/i.test(userAgent)) {
    return 'windows-phone';
  }

  if (/android/i.test(userAgent)) {
    return 'android';
  }

  if (/iPad|iPhone|iPod/.test(userAgent)) {
    return 'ios';
  }

  if (/Mac/i.test(userAgent)) {
    return 'mac-os';
  }

  if (/Windows/i.test(userAgent)) {
    return 'windows';
  }

  if (/Linux/i.test(userAgent)) {
    return 'linux';
  }

  return 'unknown';
};
